import CustomIcon from '@/common/components/base/customIcon/CustomIcon';
import CustomLabel from '@/common/components/base/customLabel/CustomLabel';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import Typography from '@/common/components/base/typography/Typography';
import CardButton from '@/common/components/cardButton/CardButton';
import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import getDamagedTypeQueryOption from '@/common/queries/getDamagedType/getDamagedTypeQueryOPtion';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import getAlertsQueryOptions from '@/modules/adjusterReportModules/adjusterReport/queries/getAlerts/getAlertsQueryOptions';
import AdjusterIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/adjuster-icon.svg?react';
import BankAccountIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/bank-account.svg?react';
import CulpritAndroidIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/CulpritAndroidIcon.svg?react';
import OwnerIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/owner.svg?react';
import PropertyInsuranceIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/property-damaged.svg?react';
import RefusalReceiveDamagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/refusalReceiveDamagesIcon.svg?react';
import VehicleInformationIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/veichel-info.svg?react';
import useAddDamagedPerson from '@/modules/adjusterReportModules/IncidentParticipants/components/addDamagedPerson/hooks/useAddDamagedPerson';
import AddDamagedPersonModal from '@/modules/adjusterReportModules/IncidentParticipants/components/addDamagedPerson/modals/AddDamagedPersonModal';
import ParticipantCardWrapper from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCardWrapper/ParticipantCardWrapper';
import { ParticipantsTabType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getParticipantsTabs/getParticipantsTabs.type';
import { getParticipantsTabsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getParticipantsTabs/getParticipantsTabsQueryOptions';
import { participantsIncidentQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/participantsIncidentList/participantsIncidentQueryOptions';
import { HandleRoutesNavigation } from '@/modules/adjusterReportModules/IncidentParticipants/utils/HandleRoutesNavigation';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const DamagedInformationTabPage = () => {
  return (
    <MainLayout title="زیان‌دیده" header="titleHeader">
      <DamagedTab />
    </MainLayout>
  );
};

const DamagedTab = () => {
  const navigate = useNavigate();
  const { modal, addDamagedPerson } = useAddDamagedPerson();
  const { id, damagedId } = useParams();
  const { data, isPending: tabIsPending } = useQuery(
    getParticipantsTabsQueryOptions({
      user_type: 'damaged',
      damaged_pk: +damagedId!,
      source: 'pwa',
      id: +id!,
    }),
  );
  const { data: alert, isPending } = useQuery(
    getAlertsQueryOptions({
      user_type: 'damaged',
      damaged_pk: damagedId!,
      source: 'pwa',
      id: id!,
    }),
  );
  const { data: damagedInfo, isPending: getDamagedTypeLoading } = useQuery(
    getDamagedTypeQueryOption({
      damaged_pk: damagedId,
    }),
  );
  const { data: damageList } = useQuery({
    ...participantsIncidentQueryOptions({
      id: id!,
    }),
  });
  const refusalReceiveDamages = alert?.alert_detail?.find(
    (item) => item.type === 'refusal_receive_damages',
  );
  const renderRoute = (item: ParticipantsTabType) => {
    const editAble = !!item.editable;

    let tabIcon: Record<
      ParticipantsTabType['name'],
      { name: string; replace: boolean }
    > = {
      owner: {
        name:
          damagedInfo?.damaged_type === 'OTHER'
            ? HandleRoutesNavigation({
                edit: ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
                  damagedId: +damagedId!,
                  id: +id!,
                }).DRIVER_OWNER_INFORMATION.otherDamaged,
                show: ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
                  damagedId: +damagedId!,
                  id: +id!,
                }).DRIVER_OWNER_INFORMATION.otherShow,
                isEditable: editAble,
              })
            : HandleRoutesNavigation({
                edit: ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
                  damagedId: +damagedId!,
                  id: +id!,
                }).DRIVER_OWNER_INFORMATION.driver,
                show: ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
                  damagedId: +damagedId!,
                  id: +id!,
                }).DRIVER_OWNER_INFORMATION.show,
                isEditable: editAble,
              }),
        replace: false,
      },
      vehicle_information: {
        name: HandleRoutesNavigation({
          edit: ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
            damagedId: +damagedId!,
            id: +id!,
          }).VEHICLE_INFORMATION.partOne,
          show: ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
            damagedId: +damagedId!,
            id: +id!,
          }).VEHICLE_INFORMATION.show,
          isEditable: editAble,
        }),

        replace: false,
      },
      bank: {
        name: HandleRoutesNavigation({
          edit: ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
            damagedId: +damagedId!,
            id: +id!,
          }).BANK_ACCOUNT.edit,
          show: ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
            damagedId: +damagedId!,
            id: +id!,
          }).BANK_ACCOUNT.show,
          isEditable: editAble,
        }),
        replace: false,
      },
      property_insurance: {
        name: HandleRoutesNavigation({
          edit: ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
            damagedId: +damagedId!,
            id: +id!,
          }).PROPERTY_INSURANCE.edit,
          show: ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
            damagedId: +damagedId!,
            id: +id!,
          }).PROPERTY_INSURANCE.show,
          isEditable: editAble,
        }),
        replace: false,
      },

      adjusting: {
        name: ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
          damagedId: +damagedId!,
          id: +id!,
        }).EXPERT.entryTabs,
        replace: false,
      },
    };
    navigate(tabIcon[item.name]?.name, {
      replace: tabIcon[item.name]?.replace,
    });
  };

  const goToFile = (item: ParticipantsTabType) => {
    renderRoute(item);
  };
  if (tabIsPending || isPending || getDamagedTypeLoading) {
    return <LoadingPage />;
  }
  return (
    <Box pt="1rem">
      <ParticipantCardWrapper
        addDamagedPerson={
          damageList && damageList?.damages.length === 1
            ? addDamagedPerson
            : undefined
        }
        length={damageList?.damages.length}
      >
        {' '}
      </ParticipantCardWrapper>

      <Box
        className={css({
          border: '2px solid #F0EEFF',
          borderRadius: '34px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1rem',
          paddingX: '17px',
          height: '40px',
          width: 'fit-content',
          mt: '1rem',
        })}
      >
        <CulpritAndroidIcon />
        <Box
          className={css({
            display: 'flex',
            flexDirection: 'row',
            gap: '0.25rem',
          })}
        >
          <Typography textStyle={'b1'} color="purple-1">
            {(alert?.first_name || '') + ' ' + (alert?.last_name || '')}
          </Typography>
        </Box>
      </Box>
      {refusalReceiveDamages && (
        <Flex
          background={'purpleLinear'}
          borderRadius={8}
          px={16}
          py={4}
          alignItems="center"
          gap={16}
        >
          <Box>
            <RefusalReceiveDamagesIcon />
          </Box>
          <Box>
            <Typography textStyle={'b1'} color="purple-1" textAlign="center">
              زیان‌دیده از دریافت مبلغ خسارت انصراف داده است.
            </Typography>
          </Box>
        </Flex>
      )}
      {isPending ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <>
          {data?.map((item) =>
            item?.is_card_active ? (
              <CardButton
                key={item?.name}
                cardProps={{
                  className: css({ marginY: '1rem' }),
                  onClick: () => item?.is_card_active && goToFile(item),
                  cursor: item?.is_card_active ? 'pointer' : 'not-allowed',
                }}
                hasArrow={item?.is_card_active}
                renderTag={() =>
                  item?.label &&
                  item?.is_card_active && (
                    <CustomLabel
                      title={item?.label?.fa_const}
                      color={
                        item?.label?.const === 'completed' ? 'green' : 'yellow'
                      }
                    />
                  )
                }
                renderIcon={() => renderIcon(item?.name)}
                title={item?.fa_name}
                subtitle={!item.label}
              />
            ) : null,
          )}
        </>
      )}
      <AddDamagedPersonModal closeModal={modal.closeModal} open={modal.open} />
    </Box>
  );
};

const renderIcon = (tabName: ParticipantsTabType['name']) => {
  let tabIcon: Record<ParticipantsTabType['name'], React.JSX.Element> = {
    adjusting: <AdjusterIcon />,
    bank: <BankAccountIcon />,
    owner: <OwnerIcon />,
    property_insurance: (
      <CustomIcon backgroundColor="orange-3" height={40} width={40}>
        <PropertyInsuranceIcon stroke={token('colors.orange')} />
      </CustomIcon>
    ),
    vehicle_information: <VehicleInformationIcon />,
  };
  return tabIcon[tabName];
};
export default DamagedInformationTabPage;
